import { IconName } from 'components/ui';

type SidebarLinkData = {
  title: string;
  url: string;
  iconName: IconName;
};

export const data: SidebarLinkData[] = [
  {
    title: 'Dashboard',
    url: '/dashboard',
    iconName: 'dashboard',
  },
  {
    title: 'Records & Forms',
    url: '/records-and-forms',
    iconName: 'record',
  },
  {
    title: 'Dependents',
    url: '/dependents',
    iconName: 'dependents',
  },
  {
    title: 'Favorite Providers',
    url: '/favorites-providers',
    iconName: 'star',
  },
  {
    title: 'Support',
    url: '/support',
    iconName: 'support',
  },
];
